function toggleFaq(element) {
  const faqAnswer = element.nextElementSibling;
  const iconPlus = element.querySelector('.icon-plus');
  const iconMinus = element.querySelector('.icon-minus');
  
  // Check if this FAQ is currently open
  const isOpen = faqAnswer.style.display === 'block';
  
  // Close all FAQs first (accordion behavior)
  const allFaqHeadings = document.querySelectorAll('.faq-heading');
  allFaqHeadings.forEach(heading => {
    const answer = heading.nextElementSibling;
    const plus = heading.querySelector('.icon-plus');
    const minus = heading.querySelector('.icon-minus');
    
    if (answer && answer.classList.contains('faq-answer')) {
      answer.style.display = 'none';
      if (plus) plus.style.display = 'inline';
      if (minus) minus.style.display = 'none';
    }
  });
  
  // If the clicked FAQ was closed, open it now
  if (!isOpen) {
    faqAnswer.style.display = 'block';
    iconPlus.style.display = 'none';
    iconMinus.style.display = 'inline';
  }
}

// Use event delegation for better performance and dynamic content support
function initFaqListeners() {
  // Use event delegation on the document or a parent container
  document.addEventListener('click', function(event) {
    const faqHeading = event.target.closest('.faq-heading');
    if (faqHeading) {
      toggleFaq(faqHeading);
    }
  });
}

// Initialize event listeners when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFaqListeners);
} else {
  initFaqListeners();
}
